import { dialog } from "../../nq-component";
import React from "react";

function DialogExists({ message, children, onOk }) {
  const handleOk = () => {
    dialog.close();
    onOk?.();
  };

  return (
    <>
      <div></div>
      <div className="p-4">
        <div className="d-flex align-items-center gap-3">
          <div className="align-self-start">
            <i
              className="bi bi-info-circle fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
          </div>
          <div className="d-flex flex-column container-fluid">
            <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
              Warning
            </h5>
            <p>{message}</p>
            {children}
          </div>
        </div>
      </div>
      <div className="text-center mb-3">
        <>
          <>
            <button
              className="btn text-white ms-2"
              style={{ backgroundColor: "#D18237" }}
              onClick={handleOk}
            >
              OK
            </button>
          </>
        </>
      </div>
    </>
  );
}

export default DialogExists;
